import * as React from "react";
import Appointment from "../../model/appointment/Appointment";
import {Option} from "ts-option";
import SectionSeparator from "../layout/section/SectionSeparator";
import Loading from "../ui/loading/Loading";
import AddAppointmentModal from "./AddAppointmentModal";
import AppointmentsTable from "./AppointmentsTable";
import ButtonSecondary from "../../hiberUiKit/src/atoms/Buttons/ButtonSecondary";

interface ComponentProps {
	/**
	 * Lead identifier
	 */
	leadId: Option<string>;
	/**
	 *
	 */
	appointmentToEdit: Option<Appointment>
	/**
	 * Appointment update callback
	 * @param {Appointment} appointment
	 * @param {Option<string>} leadId
	 */
	updateAppointment: (appointment: Appointment, leadId: Option<string>) => void;
	/**
	 * Appointment create callback
	 * @param {Appointment} appointment
	 * @param {Option<string>} leadId
	 */
	createAppointment: (appointment: Appointment, leadId: Option<string>) => void;
	/**
	 * Array of appointments
	 */
	appointments: Option<Appointment[]>
	/**
	 * Indicates if data is loading.
	 */
	isLoading: boolean;
	/**
	 * Edit appointment callback
	 * @param {Appointment} appointment
	 */
	onEditAppointmentsBtnClick: (appointment: Appointment) => void
	/**
	 * Appointment modal window is visible
	 */
	appointmentModalVisible: boolean
	/**
	 * Add appointment callback
	 */
	onAddClick: () => void;
	/**
	 * Close modal callback
	 */
	onClose: () => void;
	/**
	 * On appointment date change callback
	 * @param {Appointment} appointment
	 */
	onValueChange: (appointment: Appointment) => void
	/**
	 * Indicates that add appointment is possible
	 */
	addAppointmentPossible?: boolean
	/**
	 * Custom class for appointments table.
	 */
	tableCustomClass?: string
	/**
	 * Lead form contact. Needed to show appointment confirmation during lead creation.
	 */
	leadFormContactId: Option<string>;
}


export default class AppointmentFormBody extends React.Component<ComponentProps, {}> {

	render() {
		const appointmentsLength = this.props.appointments.getOrElse([]).length;
		return (
			<div className={"c-appointments-row"}>
				<strong>Appointments</strong>
				{this.props.addAppointmentPossible && <ButtonSecondary label={"Add appointments"}
																	   onClick={this.props.onAddClick}/>}
				{appointmentsLength == 0 && <SectionSeparator style={{margin: "30px -25px 30px -25px"}}/>}
				<Loading isLoading={this.props.isLoading}>
					{appointmentsLength > 0 &&
					<AppointmentsTable appointments={this.props.appointments}
									   editAppointment={this.props.onEditAppointmentsBtnClick}
									   onAppointmentStatusChange={(a) => this.props.updateAppointment(a, this.props.leadId)}
									   tableCustomClass={this.props.tableCustomClass}
									   leadFormContactId={this.props.leadFormContactId}/>
					}
				</Loading>
				{this.props.appointmentModalVisible &&
				<div className={"c-appointment-modal"}>
					<AddAppointmentModal appointmentToEdit={this.props.appointmentToEdit}
										 label={"Add Appointment"}
										 onChange={this.props.onValueChange}
										 onClose={this.props.onClose}
										 leadFormContactId={this.props.leadFormContactId}
					/>
				</div>
				}
			</div>
		)
	}
}